import { Code2, Smartphone, Server, Search, Wrench, Printer, Monitor, ShieldCheck } from "lucide-react";

export const SERVICES = [
  {
    slug: "web-development",
    title: "Web Development",
    short: "High-performance websites, web apps & SaaS platforms.",
    icon: Code2,
    color: "from-blue-500 to-cyan-400",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1400&q=80",
    capabilities: [
      "Custom web applications (React, Next.js, Node)",
      "Headless CMS & e-commerce stacks",
      "API design (REST/GraphQL) and integrations",
      "Progressive Web Apps and SEO-first builds",
    ],
    description:
      "From marketing sites to mission-critical web platforms, our engineering team ships scalable, secure, and lightning-fast experiences — designed for conversion and engineered for uptime.",
  },
  {
    slug: "android-development",
    title: "Android App Development",
    short: "Native & cross-platform Android apps users love.",
    icon: Smartphone,
    color: "from-emerald-500 to-teal-400",
    image: "https://images.unsplash.com/photo-1607252650355-f7fd0460ccdb?w=1400&q=80",
    capabilities: [
      "Native Kotlin / Jetpack Compose",
      "Flutter / React Native cross-platform",
      "Play Store deployment & ASO optimization",
      "Secure auth, payments & cloud sync",
    ],
    description:
      "Beautiful, performant Android apps engineered to scale — with offline-first capability, secure auth, and analytics baked in from day one.",
  },
  {
    slug: "server-management",
    title: "Physical & Virtual Server Management",
    short: "24/7 NOC, virtualization, backup & disaster recovery.",
    icon: Server,
    color: "from-indigo-500 to-blue-500",
    image: "https://images.pexels.com/photos/17489163/pexels-photo-17489163.jpeg?w=1400",
    capabilities: [
      "On-prem & cloud server provisioning (AWS, Azure, GCP)",
      "Virtualization with VMware, Hyper-V, KVM",
      "Backup, DR & high-availability clusters",
      "24×7 monitoring, patching & incident response",
    ],
    description:
      "We run servers so your team doesn't have to. From single rack deployments to multi-region cloud fleets, our NOC keeps you up — measured against strict uptime SLAs.",
  },
  {
    slug: "seo",
    title: "SEO Services",
    short: "Rank higher, convert better — measurable SEO.",
    icon: Search,
    color: "from-amber-500 to-orange-400",
    image: "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=1400&q=80",
    capabilities: [
      "Technical SEO audits & Core Web Vitals fixes",
      "Keyword strategy, content & on-page optimization",
      "Link building & domain authority growth",
      "Local SEO and Google Business optimization",
    ],
    description:
      "Visibility you can measure. Our SEO consultants combine technical depth with content strategy to compound organic growth, month over month.",
  },
  {
    slug: "hardware-repair",
    title: "Hardware & Software Repair",
    short: "Laptops, computers, printers & software troubleshooting.",
    icon: Wrench,
    color: "from-pink-500 to-rose-400",
    image: "https://images.unsplash.com/photo-1721332154191-ba5f1534266e?w=1400&q=80",
    capabilities: [
      "Laptop & desktop diagnostics + repair",
      "Printer servicing (LaserJet, inkjet, network printers)",
      "OS install, malware removal, data recovery",
      "On-site or pickup-and-return service",
    ],
    description:
      "Certified technicians for every kind of breakdown — from BSODs to dead motherboards. We diagnose fast, quote transparently, and turn devices around the same day where possible.",
  },
];

export const SERVICE_TYPES = [
  { value: "web_dev", label: "Web Development", icon: Code2 },
  { value: "android_dev", label: "Android App Development", icon: Smartphone },
  { value: "server_mgmt", label: "Server Management", icon: Server },
  { value: "seo", label: "SEO Services", icon: Search },
  { value: "hardware_repair", label: "Hardware Repair", icon: Monitor },
  { value: "software_troubleshoot", label: "Software Troubleshooting", icon: ShieldCheck },
  { value: "printer_repair", label: "Printer Repair", icon: Printer },
];
